import Vue from 'vue';

import { database } from '@/database';

export default {
  namespaced: true,
  state: {
    subscribed: false,
    byUid: null,
  },
  mutations: {
    updateAll(state, players) {
      Vue.set(state, 'byUid', players);
    },
    subscribe(state) {
      Vue.set(state, 'subscribed', true);
    },
  },
  actions: {
    subscribe({ commit, state }) {
      if (state.subscribed) {
        return;
      }
      commit('subscribe');
      database.ref('players')
        .on('value', (snapshot) => {
          commit('updateAll', snapshot.val());
        });
    },
  },
};
